export default {
  cancelSuccessText: '',
  cancelSuccessTip: ''
}
